(() => {
  const onReady = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  onReady(() => {
    const menuButton = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (menuButton && menu) {
      menuButton.addEventListener('click', () => {
        const open = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!open));
        menu.hidden = open;
      });
    }

    document.querySelectorAll('[data-modal-open]').forEach((trigger) => {
      const modal = document.getElementById(trigger.dataset.modalOpen);
      if (!modal) return;
      let priorFocus;
      const close = () => {
        modal.hidden = true;
        document.body.classList.remove('modal-open');
        priorFocus?.focus();
      };
      trigger.addEventListener('click', () => {
        priorFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('modal-open');
        modal.querySelector('[data-modal-close]')?.focus();
      });
      modal.querySelectorAll('[data-modal-close]').forEach((button) => button.addEventListener('click', close));
      modal.addEventListener('click', (event) => { if (event.target === modal) close(); });
      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
        if (event.key !== 'Tab') return;
        const items = [...modal.querySelectorAll('button,a,[tabindex]:not([tabindex="-1"])')];
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    });

    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const dataNode = root.querySelector('[data-variant-data]');
      if (!dataNode) return;
      let productData;
      try { productData = JSON.parse(dataNode.textContent); } catch (_) { return; }
      const selected = [...root.querySelectorAll('[data-option-group]')].map((group) => group.querySelector('[aria-pressed="true"]')?.dataset.optionValue || '');
      const findVariant = () => productData.variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
      const update = () => {
        const variant = findVariant();
        if (!variant) return;
        const idInput = root.querySelector('[name="id"]');
        if (idInput) idInput.value = variant.id;
        const price = root.querySelector('[data-variant-price]');
        if (price) price.textContent = variant.price;
        const status = root.querySelector('[data-stock-status]');
        const dispatch = root.querySelector('[data-dispatch]');
        const inStock = variant.quantity > 0;
        if (status) {
          status.textContent = inStock ? 'IN STOCK ♡' : 'PRE-ORDER ♡';
          status.dataset.state = inStock ? 'stock' : 'preorder';
        }
        if (dispatch) dispatch.textContent = inStock ? 'Ships within 15 days.' : 'Ships within 30 days.';
        const submit = root.querySelector('[type="submit"]');
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? 'ADD TO BAG ♡' : 'UNAVAILABLE';
        }
        if (history.replaceState && variant.url) history.replaceState({}, '', variant.url);
      };
      root.querySelectorAll('[data-option-button]').forEach((button) => button.addEventListener('click', () => {
        const position = Number(button.dataset.optionPosition);
        selected[position] = button.dataset.optionValue;
        const group = button.closest('[data-option-group]');
        group.querySelectorAll('[data-option-button]').forEach((item) => {
          const active = item === button;
          item.setAttribute('aria-pressed', String(active));
          item.classList.toggle('is-selected', active);
        });
        const label = group.querySelector('[data-selected-option]');
        if (label) label.textContent = button.dataset.optionValue;
        update();
      }));
      update();
    });
  });
})();

